import common from './common';
import till from './till';
import payment from './payment';
import receipt from './receipt';
import dialogs from './dialogs';
import customer from './customer';
import display from './display';
import products from './products';
import returns from './returns';
import reports from './reports';
import ready from './ready';
import platform from './platform';
import margin from './margin';

/**
 * English: the source of every key. One file per area of the app, merged here; a key must be
 * unique across the files (i18n.test.ts checks). Every other language mirrors these files.
 */
export const AREAS = { common, till, payment, receipt, dialogs, customer, display, products, returns, reports, ready, platform, margin } as const;

export const en = {
  ...common,
  ...till,
  ...payment,
  ...receipt,
  ...dialogs,
  ...customer,
  ...display,
  ...products,
  ...returns,
  ...reports,
  ...ready,
  ...platform,
  ...margin,
} as const;

export type MessageKey = keyof typeof en;
